/*
  COREEX cart recommendation — client-side variant resolution.

  <coreex-rec-variants> wraps one <select> per product option. On any change it
  matches the chosen option values to a variant from data-variants, then updates:
    - the hidden name="id" input (so Focal's <form is="product-form"> adds the
      right variant),
    - the price display (pre-formatted strings from the JSON — no currency
      formatting in JS),
    - the Add button's availability.

  The element re-initialises itself each time it connects, which covers the cart
  drawer re-rendering its recommendation on every cart change.
*/
(function () {
  'use strict';

  var RecVariants = class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      try {
        this.variants = JSON.parse(this.getAttribute('data-variants') || '[]');
      } catch (e) {
        this.variants = [];
      }

      this.selects = Array.prototype.slice.call(this.querySelectorAll('.coreex-cart-rec__select'));
      var card = this.closest('.coreex-cart-rec__card');
      this.form = this.closest('form');
      this.idInput = this.form ? this.form.querySelector('[data-rec-variant-id]') : null;
      this.addButton = this.form ? this.form.querySelector('.coreex-cart-rec__add') : null;
      this.priceEl = card ? card.querySelector('[data-rec-price]') : null;

      var self = this;
      this.selects.forEach(function (select) {
        select.addEventListener('change', function () {
          self.update();
        });
      });

      this.update();
    }

    matchVariant() {
      var chosen = this.selects.map(function (s) {
        return s.value;
      });

      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        var opts = v.options || [];
        var all = true;
        for (var j = 0; j < chosen.length; j++) {
          if (opts[j] !== chosen[j]) {
            all = false;
            break;
          }
        }
        if (all) return v;
      }
      return null;
    }

    update() {
      var variant = this.matchVariant();
      if (!variant) return;

      if (this.idInput) this.idInput.value = variant.id;

      if (this.priceEl) {
        var html = '<span class="coreex-cart-rec__price-current">' + variant.price + '</span>';
        if (variant.compare) {
          html += '<s class="coreex-cart-rec__price-compare">' + variant.compare + '</s>';
        }
        this.priceEl.innerHTML = html;
      }

      if (this.addButton) {
        this.addButton.disabled = !variant.available;
      }
    }
  };

  if (!window.customElements.get('coreex-rec-variants')) {
    window.customElements.define('coreex-rec-variants', RecVariants);
  }
})();
